import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, Inject, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core'; 
import { ActivatedRoute, Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";  
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader'; 
import { AppConsts } from '@shared/app-consts';  
import { ResetPasswordRequest } from '@shared/ResetPasswordRequest';
import { GRecaptchaService } from '@services/grecaptcha.service';


@Component({
  selector: 'app-send-token-possword',
  templateUrl: './send-token-possword.component.html',
  styleUrls: ['./send-token-possword.component.scss'] 
})
export class SendTokenResetPasswordComponent implements OnInit  { 
    submitted:boolean=false;
    resetPasswordForm:FormGroup;      
    resetPasswordModel:ResetPasswordRequest;
    email:string;
    infoMessage:string;   
    step:number = 1;
    emailPattern: string = AppConsts.EMAIL_PATTERN;
    get f() { return this.resetPasswordForm.controls; }
    submitWithCaptcha = GRecaptchaService.submitWithCaptcha;

    constructor(private route: ActivatedRoute,private service: AuthenticationService,
      private router: Router,
      public formBuilder: FormBuilder,
      private loaderService: LoaderService, private renderer: Renderer2,
      @Inject(DOCUMENT) private _document,  private zone: NgZone) {
      }

        
  ngOnInit() {  
    this.step = 1;
    this.resetPasswordModel = new ResetPasswordRequest('','');  
    this.buildForm(); 
  }

  ngAfterViewInit() { 
  }  

 buildForm(){
    this.resetPasswordForm = this.formBuilder.group({ 
      Email: [
        "",
        Validators.compose([
          Validators.maxLength(100),
          Validators.pattern(this.emailPattern),
          Validators.required
        ])
      ]
    });
    
    this.resetPasswordForm.controls['Email'].valueChanges.subscribe((value) => {  
        this.resetPasswordModel.Email = value; 
        }); 
 }

 handleValidSubmit = (event) =>{
  event.preventDefault();
  this.submitWithCaptcha(this.sendMailTokenPassword.bind(this),event,"submit");
}

 sendMailTokenPassword(event, recaptchaToken){
  this.submitted = true;
  
  if(this.resetPasswordForm.invalid)
     return;      

   this.resetPasswordModel.RecaptchaToken =  recaptchaToken;
   this.loaderService.showLoader();
   this.service.sendmailforresetpassword(this.resetPasswordModel).subscribe((response : any)=>{
   this.loaderService.hideLoader();  
    if(response != null && response)
    {
      this.step = 2;
    }
  },(error)=>{
     this.loaderService.hideLoader();
  }); 
 } 

 redirectToLogin(){
  this.router.navigate(['/login']);
 }
}